import { Text } from '@user-portal/wikr-components';

import { WorkoutPlanType } from 'types/workouts';

import PlanItem from '../PlanItem/PlanItem';

import * as S from './styled';

type PlanContainerProps = {
    plan: (WorkoutPlanType & { done: boolean })[];
    onClick: (item: Pick<WorkoutPlanType, 'hash' | 'workout_id'>) => void;
    copy: {
        header: string;
    };
};

export const PlanContainer = ({ plan, onClick, copy: { header } }: PlanContainerProps) => (
    <>
        <Text type="large-text">{header}</Text>
        <S.Container>
            {plan.map((item, index) => (
                <PlanItem key={index} plan={item} onClick={onClick} done={item.done} />
            ))}
        </S.Container>
    </>
);
